import { render, staticRenderFns } from "./VehicleManage.vue?vue&type=template&id=0c6f937f&scoped=true"
import script from "./VehicleManage.vue?vue&type=script&lang=js"
export * from "./VehicleManage.vue?vue&type=script&lang=js"
import style0 from "./VehicleManage.vue?vue&type=style&index=0&id=0c6f937f&prod&scoped=true&lang=css"
import style1 from "./VehicleManage.vue?vue&type=style&index=1&id=0c6f937f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f937f",
  null
  
)

export default component.exports